import React from 'react';
import { toast } from 'react-toastify';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button, Card, Descriptions, Select, Space, Table, TablePaginationConfig } from 'antd';
import Column from 'antd/lib/table/Column';
import api from '@services/api';
import { ReportForIncorrectRequestsResponse, ReportForIncorrectRequestsSummaryResponse } from '@openapi';
import { useHistory, useParams } from 'react-router-dom';
import { Navigation } from '@constants/Navigation';

const IncorrectRequests = () => {
  const params = useParams<{ period: string }>();
  const history = useHistory();
  const [period, setPeriod] = React.useState(params.period);
  const [incorrectSum, setIncorrectSum] = React.useState<ReportForIncorrectRequestsSummaryResponse>();
  const [reports, setReports] = React.useState<ReportForIncorrectRequestsResponse['incorrectRequestElements']>();
  const [pagination, setPagination] = React.useState<TablePaginationConfig>({
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    total: reports?.length,
  });
  React.useEffect(() => {
    api.reports.getDeviceReq().then(setIncorrectSum);
    handleChangePeriod();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    api.reports
      .getIncorrectRequestsReport({ period: params.period })
      .then(({ incorrectRequestElements }) => setReports(incorrectRequestElements));
  }, [params.period]);

  const handleChangePeriod = React.useCallback(() => {
    history.push(Navigation.IncorrectRequests.replace(':period', period));
  }, [history, period]);

  const reportCount = (pagination.pageSize || 0) * (pagination.current || 0);
  const reportItem = (reportCount || 0) - ((pagination.pageSize || 0) - 1);

  return (
    <Space direction="vertical">
      <Card title="Incorrect requests">
        <Descriptions column={4}>
          <Descriptions.Item label="Today">{incorrectSum?.countWithinLast1D}</Descriptions.Item>
          <Descriptions.Item label="Today and Yesterday">{incorrectSum?.countWithinLast2D}</Descriptions.Item>
          <Descriptions.Item label="This month">{incorrectSum?.countWithinLast1M}</Descriptions.Item>
          <Descriptions.Item label="This month and last month">{incorrectSum?.countWithinLast2M}</Descriptions.Item>
        </Descriptions>
      </Card>
      <Card
        title={`INCORRECT REQUESTS: ${reportItem}-${reportCount} / ${reports?.length}`}
        extra={
          <Space>
            <Select value={period} onChange={setPeriod}>
              <Select.Option value="1D">Today</Select.Option>
              <Select.Option value="2D">Today and Yesterday</Select.Option>
              <Select.Option value="1M">This month</Select.Option>
              <Select.Option value="2M">This month and last month</Select.Option>
            </Select>
            <Button onClick={handleChangePeriod} type="primary">
              Submit
            </Button>
          </Space>
        }
        bodyStyle={{ padding: 0 }}
      >
        <Table dataSource={reports || []} pagination={{ showSizeChanger: true }} rowKey={(record) => record.id}>
          <Column title="Date hour" dataIndex="date" render={(date: Date | null) => date?.toLocaleString()} />
          <Column title="Code" dataIndex="code" />
          <Column title="Message" dataIndex="message" />
          <Column
            title="Request"
            dataIndex="request"
            ellipsis
            render={(text) => (
              <CopyToClipboard text={text} onCopy={() => toast.success('Request copied to clipboard')}>
                <span title="Click to copy">{text}</span>
              </CopyToClipboard>
            )}
          />
        </Table>
      </Card>
    </Space>
  );
};

export default React.memo(IncorrectRequests);
